import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.nav.users');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { HostListener } from '@angular/core';

@Component({
    selector: 'wiz-component-nav-users',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.nav.users/view.scss */
@charset "UTF-8";
.nav-link {
  cursor: pointer;
  color: #5D5D5D;
  font: normal normal normal 18px/21px NanumSquareOTF;
}
.nav-link.active {
  color: #5263FF;
  font-weight: bold;
}
.nav-link ::after {
  content: "";
  display: block;
  color: #5263FF;
}

.d-none {
  gap: 0.5rem;
}

.text-reset {
  height: 50px;
  width: 50px;
  border: solid 1px;
  border-radius: 20px !important;
}

.tooltip-wrapper {
  position: relative;
  display: block;
}
.tooltip-wrapper .tooltip-text {
  visibility: hidden;
  opacity: 0;
  background-color: #333;
  color: #fff;
  text-align: center;
  border-radius: 4px;
  padding: 6px 10px;
  position: absolute;
  z-index: 1000;
  bottom: 100%;
  /* 텍스트가 위에 뜨도록 */
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  transition: opacity 0.2s ease-in-out;
  font-size: 12px;
  margin-bottom: 8px;
}
.tooltip-wrapper:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
}

.nav-item.dropdown .dropdown-toggle::after {
  display: none;
}

/* 공지사항 드롭다운 */
#notice-dropdown .dropdown-menu {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  background-color: #fff;
  min-width: 148px;
  max-width: 148px;
  padding: 0;
  border-radius: 10px 10px 10px 10px;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.1);
  z-index: 1050;
}

#notice-dropdown:hover .dropdown-menu {
  display: block;
}

/* 기관현황 드롭다운 */
#institutes-dropdown .dropdown-menu {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  background-color: #fff;
  min-width: 148px;
  max-width: 148px;
  padding: 0;
  border-radius: 10px 10px 10px 10px;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.1);
  z-index: 1050;
}

#institutes-dropdown:hover .dropdown-menu {
  display: block;
}

/* 첨단연구지원 드롭다운 */
#research-dropdown .dropdown-menu {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  background-color: #fff;
  min-width: 148px;
  max-width: 148px;
  padding: 0;
  border-radius: 10px 10px 10px 10px;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.1);
  z-index: 1050;
}

#research-dropdown:hover .dropdown-menu {
  display: block;
}

/* 드롭다운 항목 스타일 */
.dropdown-item {
  padding: 1rem 1.5rem;
  color: #5D5D5D;
  min-width: 0;
  text-align: center;
  display: block;
  text-decoration: none;
  font: NanumSquareOTF;
}
.dropdown-item:hover {
  background-color: #DDE8FF;
  color: #5263FF;
  font-weight: bold;
}

.nav-item {
  width: 128px;
  height: 46px;
}

.navbar {
  background: none;
}

.container-xl {
  max-width: 1800px;
  padding: 0;
}

.navbar-brand {
  margin-right: 1rem;
  padding-left: 0.5rem;
}
@media (max-width: 992px) {
  .navbar-brand {
    margin-right: 0;
  }
}

.navbar-nav {
  padding-right: 0.5rem;
}`],
})
export class ComponentNavUsersComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public institute_ns = '';
    public async ngOnInit() {
        await this.service.init();
        console.log(this.service.auth)
    }

    @HostListener('document:click')
    public clickout() {
        this.service.navbar.toggle(true);
    }

    public async collapse() {
        this.isMenuCollapsed = !this.isMenuCollapsed;
        await this.service.render();
    }
    public isActive(link: string) {
        return location.pathname.indexOf(link) === 0
    }

}

export default ComponentNavUsersComponent;